import React, { Component } from 'react';
import $ from 'jquery'


class OutsourcingISIT extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="co-je-to-outsourcing">
            <h1>Outsourcing - Co je to outsourcing</h1>
            <span>
            Outsourcing v podstatě znamená zajišťování části provozu organizace jinou, externí organizací. Je to označení, které vychází ze dvou základních slov: "out" - vnější a "source" - zdroj, tedy jak bylo řečeno v první větě, je to zajištění činnosti na základě vnějších zdrojů.
<br/><br/>
                <h2>Historie outsorcingu</h2>
            Historie outsourcingu se táhne daleko do minulosti. Denně se s ním setkáváme v různých odvětvích, nejčastěji například v autodopravě. Outsourcing IT jako takový má počátky někde na konci sedmdesátých let. V letech osmdesátých se již stal pro velké koncerny naprosto běžnou záležitostí a dnes se s ním setkáme u všech podnikatelských subjektů, které již objevili jeho výhody. V oblasti IT jsou ty firmy, které zjistily, že vývoj a údržba jejich informačního systému na základě vnitřních zdrojů je příliš nákladná nebo z jakéhokoliv jiného ekonomického hlediska nevýhodná.
<br/><br/>
            <h2>Outsourcing obecně</h2>
            Jak bylo řečeno, outsourcing je forma spolupráce, která musí být založena na dlouhodobých vztazích. V prvé řadě je nutné, aby zadavatel zcela jasně vymezil a definoval vlastní podnikové procesy. Jde o stanovení důležitosti informačního systému na samotný běh podniku a určení jaká je jeho část, nebo zda celek je vhodný pro outsorcing. Je dobré vzít v potaz, že předmětem outsorcingu mohou být všechny procesy informačního systému. Zjednodušeně a laicky by se dalo říci, že lze určitou práci přenést na někoho jiného o kom víme, že je mnohem lepší než my, ví co dělá a bude za svou práci plně zodpovědný.
<br/><br/>
            <h2>Přínos outsorcingu</h2>
            <h2>Ekonomické výhody</h2>
            Přínosem outsourcingu jsou v prvé řadě výhody ekonomické. V České republice panuje mylná domněnka, že vše co si můžeme udělat sami je levnější. Není tomu však tak. Vlastní správa IT bývá mnohdy nákladnější než u outsorcingového řešení. Pokud se na tento problém podíváte zběžně, může to vypadat, že tomu tak není, ale pokud půjdete do hloubky, zjistíte, že vlatní správa informačního systému obsahuje prvky, se kterými jste v první kalkulaci nákladů nepočítaly. Tento faktor bude mít na výslednou kalkulaci velký vliv. Uveďme si tedy pár příkladů:
                <br/>
                <li>Konzultační služby pro vývoj informačního systému</li>
           <li>Náklady na výběr nových technologií</li>
            <li>Likvidace zastaralých technologií</li>
            <li>Testování nových technologií před implementací</li>
            <li>Podpůrné technologie, které nejsou plně využité</li>
            <li>Organizační náklady pro pracovníky</li>
           <li>Školení operátorů, administrátorů a programátorů</li>
            <li>Exaktní přehled nákladů na informační systém</li>
          <li>Kalkulované, pravidelné a plánované náklady</li>
           <li>Vlastní riziko při výpadku informačního systému</li>
  <br/>
            Toto jsou náklady, které je nutno vzít v potaz. Nestačí pouze přijít a nakoupit. Informační systém má mnoho skrytých zákoutí, které se před vámi budou otevírat velmi náhle. Je tedy nutno vzít tato úskalí na vědomí.
<br/><br/>
                <h2>Bezpečnostní výhody</h2>
            Pokud je to možné a jedná se o důležitá data, je vhodné umístit je do prostředí, které zaručuje zabezpečení před zneužitím či zcizením těchto dat. Je totiž velmi snadné podplatit nějakého pracovníka v rámci firmy, aby data okopíroval. Je tedy nutné vybudovat systém, ve kterém budou data lokalizována jinde s omezeným přístupem z vnější nebo podobný systém vytvořit přímo u zákazníka. Pokud má takovýto systém vnější správu a pracovníci mají přístupové oprávnění pouze do některých čístí systému je zabezpečení dat mnohem dokonalejší. Pokud má do maximálně zabezpečených částí přístup pouze poskytovatel outsourcingu je také na něm, aby nesl příslušnou odpovědnost za bezpečenost svěřených dat.
<br/><br/>
            <h2>Postup při poskytování outsourcingu:</h2>

            Při poskytování outsourcingových služeb je klíčové definovat předmět outsourcingu. Tedy stanovit hranice mezi jednotlivými procesy, hlavními a vedlejšími v informačím systému. Například oddělit samostaný informačním systém od systému výkoného, např. zpracování faktur. Je velmi důležité definovat pracovní procesy uvnitř organizace a na tomto základě určit tok informací. Stanoví se vlastníci těchto procesů a zodpovědnost. Po té, co se definují jednotlivé procesy, se na základě dohody se zákazníkem stanoví rozsahy, parametry a typ outsorcingových služeb.

            Outsourcing můžeme rozdělit do tří základních skupin. Na úplný outsourcing, personální outsourcing a hardwarový outsourcing.
<br/><br/>
            <h2>Úplný outsourcing</h2>
            - obsahuje dodání všech součástí informačního systému jako je např. hardware, software, údržba, podpůrné služby, odpovědnost za funkčnost systému, školení uživatelů, bezpečnost informací, plnění právních norem, atd.
<br/><br/>
            <h2>Personální outsourcing</h2>
            - zajišťuje poskytování služeb a personálu pro údržbu, zajištění funkčnosti, rozvoj informačního systému, školení uživatelů a jiné služby, které jsou nutné pro definovaný provoz informačního systému.
<br/><br/>
            <h2>Hardwarový outsourcing</h2>
            - zajišťuje činost informačního systému po stránce technické výbavy. Udržuje systém neustále vchodu pomocí dohledu nad stavem hardwaru, pravidelných profilaxí a okamžitých výměn nefunkčních součástí.

            Tyto typy se samozřejmě mohou vzájemně překrývat nebo mohou vzniknout jejich varianty na základě požadavků zákazníka.
<br/><br/>
            <h2>Co získáte outsourcingem?</h2>
            V outsorcingovém balíčku naleznete tyto služby:

                <li>Pravidelná kontrola počítačů ve Vaší firmě v intervalech daných požadavkem zákazníka.</li>
            <li>Kontrola stavu počítačů, sítě, administrace příp. dohled serverů a pracovních stanic</li>
            <li>Záruky provozuschopnosti zařízení = minimalizace prostojů</li>
            <li>Instalace nového software a hardware</li>
            <li>Garantované řešení technického problému, smluvní počet standardních profylaktických zásahů v ceně</li>
            <li>Slevy na materiál při servisu Vašich zařízení</li>
            <li>Helpdesk, poradenská činnost po Internetu a telefonicky 24 hodin denně</li>
            <li>Výhody systémové integrace</li>
            <li>Podpora Vašich pracovníků v širokém spektru SW aplikací a školení obsluhy</li>
            <li>Konzultace a poradenství a zajištění nákupu nového software a hardware včetně klientských slev</li>
            <li>Možnost nasazení progresivních a cenově dostupných technologií na bázi Linuxu</li>
           <li>Řešení virové problematiky ve vaší síti na profesionální úrovni</li>
             ... a mnoho dalších služeb odvíjejících se od konkrétních požadavků zákazníka
<br/><br/>
             <h2>Jak outsourcing funguje</h2>
            Je to vlastně systém, kdy zákazník definuje své potřeby a v souladu s poskytovatelem outsorcingu vytvoří balíček outsorcingových služeb. Tento balíček obsahuje jednotlivé prvky, které udavají předmět outsorcingu. Nejčastěji je takovýto balíček definován těmito prvky:

            <li>Paušálním počtem hodin a návštěv</li>
            <li>Typem vzdáleného dohledu a správy</li>
            <li>Rychlostí řešení jednotlivých problémů</li>
            <li>Typem a častností záloh</li>
            <li>Typem helpdesku</li>
             ... a dalšími prvky dle přání zákazníka

            Outsourcingové služby musí být velmi flexibilní, neboť není možno aplikovat stejný model na různé klienty. Potřeby budou jiné podle typu a velikosti organizace, která se rozhodla outsourcingových služeb využít. K jednotlivým klientům tedy vždy přistupujeme individuálně a hledáme řešení "šité na míru".

            Pokud bychom tedy měli outsourcing jako takový shrnout, znamená to, že: zákazník ví, nebo má alespoň představu co chce a my víme jak na to, jsme schopni realizace a údržby a to za značných hlavně ekonomických úspor.


            </span>

        </div>


</div>
    );
  }
}

export default OutsourcingISIT;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/CojetoOutsourcing.js